import { ActionIcon, Popover, TextInput } from '@mantine/core';
import { IconWorld } from '@tabler/icons-react';
import React from 'react';
import { useTheme } from '../../../context/ThemeProvider.tsx';
import { useMap } from '@vis.gl/react-google-maps';

interface SetMapCenterByLatLngValuePopoverProps {
  setSearchLatLngValue: (latLngValue: string) => void;
  defaultCenterSelectedZoom: number;
}

const SetMapCenterByLatLngValuePopover: React.FC<
  SetMapCenterByLatLngValuePopoverProps
> = ({ setSearchLatLngValue, defaultCenterSelectedZoom }) => {
  const map = useMap();
  const { colorScheme } = useTheme();

  const handleSetMapCenterByLatLngValueEnter = (searchLatLngValue: string) => {
    const [lat, lng] = searchLatLngValue
      .replaceAll(' ', '')
      .split(',')
      .map(parseFloat);

    map.setCenter({ lat, lng });
    map.setZoom(defaultCenterSelectedZoom);
    setSearchLatLngValue(searchLatLngValue);
  };

  return (
    <>
      {/* 經緯度搜尋按鈕 */}
      <Popover
        width={300}
        position="bottom"
        withArrow
        arrowOffset={5}
        closeOnClickOutside={false}
        onClose={() => setSearchLatLngValue('')}
        styles={{
          dropdown: {
            padding: '6px 15px',
            height: '96px',
          },
        }}
      >
        <Popover.Target>
          <ActionIcon
            variant="filled"
            color={colorScheme === 'light' ? '#ffffffff' : '#2e2e2e'}
            size={35}
            radius="sm"
            style={{
              border: '0.5px solid',
              borderColor: colorScheme === 'light' ? '#ced4da' : '#424242',
            }}
          >
            <IconWorld
              size={20}
              color={colorScheme === 'light' ? '#adb5bd' : '#696969'}
            />
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown>
          <div
            style={{
              width: 268,
              height: 72,
            }}
          >
            <TextInput
              label="經緯度搜尋"
              withAsterisk
              description="目前可視範圍半徑（公尺）：300 "
              placeholder="緯度, 經度"
              size="xs"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSetMapCenterByLatLngValueEnter(e.currentTarget.value);
                }
              }}
              styles={{
                wrapper: {
                  marginTop: 4,
                },
                label: {
                  fontWeight: 500,
                  fontSize: 14,
                  color: colorScheme === 'light' ? 'black' : 'white',
                  lineHeight: '20px',
                  marginTop: 0,
                  marginBottom: 0,
                },
                description: {
                  fontWeight: 400,
                  fontSize: 12,
                  color: '#868E96',
                  lineHeight: '16px',
                },
                input: {
                  height: '32px',
                },
              }}
            />
          </div>
        </Popover.Dropdown>
      </Popover>
    </>
  );
};

export default SetMapCenterByLatLngValuePopover;
